module.exports = __webpack_public_path__ + "img/avaliacao.8935c25d.svg";